export const Constants = {
  // REGEX
  REGEX_STRING_VALIDATION_SIN_ESPACIO: '^[a-zA-ZlñÑ]*$',
  // No permite espacios en ningún lado de la cadena
  REGEX_STRING_VALIDATION: '^[a-zA-ZlñÑáéíóúÁÉÍÓÚ ]*$',
  // REGEX para NIT con dígito de verificación
  REGEX_NIT_CON_DV: '^\\d{1,9}(-\\d)?$',
  // No permite espacios ni al inicio ni al final, solo espacios intermedios. Permite tíldes.
  REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS:
    '^(?!\\s)[a-zA-ZñÑáéíóúÁÉÍÓÚ.,;]+(?:\\s?[a-zA-ZñÑáéíóúÁÉÍÓÚ.,;]+)*(?<!\\s)$',
  // No permite espacios ni al inicio ni al final, solo espacios intermedios
  REGEX_STRING_WITHOUT_SPACES: '^[a-zA-ZñÑ]+([a-zA-ZñÑ\\s]*[a-zA-ZñÑ])?$',
  // No permite espacios ni al inicio ni al final, solo espacios intermedios y no permite caracteres especiales
  REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT:
    '^[a-zA-ZñÑáéíóúÁÉÍÓÚ]+( [a-zA-ZñÑáéíóúÁÉÍÓÚ]+)*$',
  // Permite letras y números, pero no permite espacios ni al inicio ni al final, solo espacios intermedios
  REGEX_ALPHANUMERIC_WITHOUT_SPACES:
    '^[A-Za-zñÑáéíóúÁÉÍÓÚ0-9]+(?:\\s[A-Za-zñÑáéíóúÁÉÍÓÚ0-9]+)*$',
  REGEX_ALPHANUMERIC_WITHOUT_SPACES_PUNTUACION:
    '^(?![.,])[\\wñÑáéíóúÁÉÍÓÚ\\s,]*(\\.[\\s\\wñÑáéíóúÁÉÍÓÚ,]*)?\\.?$',
  REGEX_ACTA_PROTESTA:
    '^(?![.,\\s])(?!.*[<>""])[\\s\\S]*[^<>"\\s.]\\.?$',
  REGEX_NOMBRE_EVENTO:
    '^(?!\\s)(?!.*[<>\\\"\'\\\\|`{}\\[\\]])[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ.,;:!?()\\-_%&/#$\\s]+(?<!\\s)$',
  REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS:
    '^(?!.*#.*#)(?!.*-.*-)[A-Za-zñÑáéíóúÁÉÍÓÚ0-9#-]+(?:\\s[A-Za-zñÑáéíóúÁÉÍÓÚ0-9#-]+)*$',
  // Permite letras y números, pero no permite espacios ni al inicio ni al final, solo espacios intermedios
  REGEX_ADDRESS: '^[A-Za-zñÑ0-9#\\-]+(?:\\s[A-Za-zñÑ0-9#\\-]+)*$',
  // Direcciones según Marco Nacional de Direcciones
  REGEX_ALPHANUMERIC_COL_ADDRESS:
    '^(?!.*#.*#)(?!.*-.*-)[a-zA-ZñÑáéíóúÁÉÍÓÚ]{2,12}\\s*\\d{1,3}(?:\\s*[A-Za-z]{1,3})?\\s*#\\s*\\d{1,3}[A-Za-z]?\\s*-\\s*\\d{1,3}([ ,]+[a-zA-ZñÑáéíóúÁÉÍÓÚ0-9#-]+)*$',
  // Permite letras y números, pero no permite espacios ni al inicio ni al final ni caracteres especiales, solo espacios intermedios
  REGEX_ALPHANUMERIC_RAZON_SOCIAL:
    '^[A-Za-zÁÉÍÓÚáéíóúÑñ0-9]+( [A-Za-zÁÉÍÓÚáéíóúÑñ0-9]+)*$',
  REGEX_SOLO_UNA_PALABRA: '^[A-Za-zÁÉÍÓÚáéíóúÑñ0-9_.\\-,]+$',
  // No permite espacios ni al inicio, ni al final
  REGEX_WITHOUT_ESPACES: '^\\S.*\\S$|^\\S$/',
  REGEX_ALFANUMERICO_VALIDATION: '^[a-zA-Z0-9 ]*$',
  REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO: '^[a-zA-Z0-9]*$',
  REGEX_PASSWORD_VALIDATION:
    '^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[@$!%*?&.])[A-Za-z\\d@$!%*?&.]{8,}$',
  REGEX_PASSWORD_VALIDATION_WITH_CHARACTERS:
    '^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[!@#$%^&*()+?"\\[\\]])[A-Za-z\\d!@#$%^&*()+?"\\[\\]]{8,}$',
  REGEX_CORREO_ELECTRONICO: '^[a-zA-Z\\d._-]+@[a-zA-Z\\d-]+(\\.[a-zA-Z]{2,}){1,2}$',
  REGEX_CORREO_ELECTRONICO_SIN_DOMINIO: '^[a-zA-Z0-9._%+-]+$',
  REGEX_TELEFONO: '^[0-9]+$',
  REGEX_SIN_ESPACIOS: '^[^\\s]+$',
  REGEX_PAGINA_WEB:
    '^(HTTPS?:\\/\\/)?([a-zA-Z0-9.-]+)(:[0-9]{1,5})?(\\/[a-zA-Z0-9._\\-~%\\/&=?]*)?$',
  REGEX_DECIMAL: '^\\d{1,3}(,\\d{3})*(\\.\\d+)?$',
  REGEX_DECIMAL_PORCENTAJE: '^(100(\\.0{1,2})?|[0-9]{1,2}(\\.\\d{1,2})?)$',
  REGEX_ONLY_LETTERS_NO_SPACES: '^[A-Za-zÁÉÍÓÚáéíóúÑñ]+$',
  REGEX_PASSWORD_STRONG:
    '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[\\W_]).+$',
  REGEX_USERNAME:'^[a-zA-Z0-9]{4,50}$',
  REGEX_DESCRIPCION:
    '^(?!\\s)[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ.,\\s]+(?<!\\s)$',
  // String
  FOOTER_INFORMATION_STORAGE: 'footer_information_session',
  USER_INFORMATION_STORAGE: 'user_information_session',
  MDJ_ACCESS_TOKEN: 'mdj_token',
  ACCESS_TOKEN: 'access_token',
  JUS_ACCESS_TOKEN: 'jwt',
  IS_SUCCESS_LOGIN: 'is_sl',
  JUSTINO_ACCESS_TOKEN: 'justino_access_token',
  FUNCIONALIDADES: 'active_functionalities',
  USER_TYPE: 'user_type',
  REFRESH_TOKEN: 'refresh_token',
  LABEL_PERSONA_NATURAL: 'persona natural',
  LABEL_PERSONA_JURIDICA: 'persona jurídica',
  casos_tipo_demanda: 'SUPERSALUD_CASOS_TIPO_DEMANDA',
  tipo_demanda: 'SUPERSALUD_TIPO_DEMANDA',
  tipo_pretension: 'SUPERSALUD_TIPO_PRETENSION',
  dominio_email: 'SUPERSALUD_DOMINIO_EMAIL',
  acumulado_metrica: 'Acumulado',
  CODIGO_COLOMBIA: 'CO',
  ID_COLOMBIA: 1,
  SFC_SEXO: 'SFC_SEXO',
  TIPOS_USUARIO: {
    ADMIN_LIDER: 'Administrador Lider',
    ADMIN_FUNCIONAL: 'Administrador Funcional',
    ADMIN_OBSERVATORIO: 'Administrador Observatorio',
    SUPERADMINISTRADOR: 'Superadministrador',
  },
  TRAMITE_SELECCIONADO: 'tramiteSeleccionado',
  NOMBRE_TRAMITE: 'nombreTramite',
  EJERCE_ABOGADO: 'ejerceAbogado',
  // Number
  MAX_FILES_ALLOW: 4,
  ENTIDAD_ID: 0,
  CEDULA_ID: 1,
  TARJETA_PROFESIONAL_ID: 6,
  FOREIGNER_ID: 4,
  DEMAND_REQUEST_CLASS_ID: 1,
  TYPE_OF_PERSON_NATURAL: '1',
  TYPE_OF_PERSON_JURIDICA: '2',
  NIT_ID: '3',
  ID_TIPO_USUARIO_ADMIN: 3,
  NORMAL_USER_IDS: [1, 2, 48],
  ERROR_VALIDANDO: 'Error validando código',
  CODIGO_NO_SATISFACTORIO: 'El código ingresado no fue satisfactorio.',

  // Dígito de verificación NIT
  NIT_DV_PESOS: [71, 67, 59, 53, 47, 43, 41, 37, 29, 23, 19, 17, 13, 7, 3],
  NIT_DV_DIVISOR: 11,
  NIT_DV_RESIDUO_CERO: 0,
  NIT_DV_RESIDUO_UNO: 1,

  //Entidades
  ID_ENTIDAD_ICA: 7,
  ID_ENTIDAD_SUPERSALUD: 3,
  ID_ENTIDAD_SUPERFINANCIERA: 4,
  ID_ENTIDAD_SUPER_SOCIEDADES: 1,
  ID_ENTIDAD_DIMAR: 6,
  ID_ENTIDAD_DNDA: 5,
  ID_ENTIDAD_SIC: 2,
  ID_ENTIDAD_SUPER_SOCIEDADES_MERCANTILES: 8,
  ID_ENTIDAD_SSO_ROI: 11,
  ID_ENTIDAD_SSO_LJI: 10,
  ID_ENTIDAD_SSO_VJI: 9,

  // ID de los tipos de usuario
  ID_TIPO_USUARIO_CIUDADANO: 1,
  ID_TIPO_USUARIO_ABOGADO: 2,

  NORMAL_USER_ROLES: [
    'JF_CIUDADANO',
    'JF_ABOGADO',
    'JF_GESTOR_EMPRESA',
    'JF_EMPRESA'
  ],
  ROL_EXTERNO_CIUDADANO: 'JF_CIUDADANO',
  ROL_EXTERNO_ABOGADO: 'JF_ABOGADO',
  ROL_EXTERNO_EMPRESA: 'JF_EMPRESA',
  ROL_EXTERNO_GESTOR_EMPRESA: 'JF_GESTOR_EMPRESA',
  // Define roles
  ROL_CIUDADANO: 'Ciudadano',
  ROL_ABOGADO: 'Abogado',
  EMPRESA: 'EMPRESA',

  ID_TIPO_TRAMITE: 5,
  TIME_REFRESH_TOKEN: 1000 * 60 * 8,

  SIN_RESPUESTA: 'N/A',
  FECHA_ORDENABLE: '0000-00-00',
  VALOR_TIMESTAMP: 0,

  // JSON
  TIPO_PERSONA: {
    NATURAL: 1,
    JURIDICA: 2,
  },

  TRAMITES: {
    SUPER_FINANCIERA: 4,
  },

  LISTAS: {
    SFC_MOTIVO: 'SFC_MOTIVO',
    SFC_PRODUCTO: 'SFC_PRODUCTO',
    SFC_CANAL: 'SFC_CANAL',
    SFC_ENTIDAD: 'SFC_ENTIDAD',
    SFC_SEXO: 'SFC_SEXO',
    SFC_TIPO_TRAMITE: 'SFC_TIPO_TRAMITE',
    SSM_ASUNTO: 'SSM_ASUNTO',
  },

  // Años requeridos
  ANIOS_REQUERIDOS: 12,
  ANIOS_ADULTO: 18,

  LISTA_TIPOS_ADMIN: 'Tipo_Usuario_Admin_Lider',

  // Tipos de trámite
  DNDA_OBTVEG: 7,
  ICA_OBTVEG: 3,
  SIC_PROCON: 2,
  SFC_PROCON: 4,
  DIMAR_COSIMAR: 6,
  SSA_COBSER: 5,
  SSO_ROI: 11,
  SSO_VJI: 9,

  USER_DOCUMENT_TYPE: 'USER_DOCUMENT_TYPE',
  USER_IDENTIFICATION: 'USER_IDENTIFICATION',
  // Archivos requeridos SIC
  ANEXO_RECLAMACION: 'Documento_Reclamacion_Directa',
  CONSTANCIA_RECLAMACION: 'Constancia_de_la_reclamacion',
  RESPUESTA_RECLAMO: 'Respuesta_Reclamo_Directo',
  RECLAMACION_VERBAL: 'TR_V',
  RECLAMACION_ESCRITA: 'TR_E',
  SHOW_GUIA_TRAMITE: 'SHOW_GUIA_TRAMITE',
  SHOW_GUIA_EXPEDIENTE: 'SHOW_GUIA_EXPEDIENTE',
  SHOW_GUIA_DETALLE_DIMAR: 'SHOW_GUIA_DETALLE_DIMAR',
  SHOW_GUIA_DETALLE_DNDA: 'SHOW_GUIA_DETALLE_DNDA',
  SHOW_GUIA_DETALLE_ICA: 'SHOW_GUIA_DETALLE_ICA',
  SHOW_GUIA_DETALLE_SIC: 'SHOW_GUIA_DETALLE_SIC',
  SHOW_GUIA_DETALLE_SUPERFINANCIERA: 'SHOW_GUIA_DETALLE_SUPERFINANCIERA',
  SHOW_GUIA_DETALLE_SUPERSALUD: 'SHOW_GUIA_DETALLE_SUPERSALUD',
  SHOW_GUIA_DETALLE_SUPERSSM: 'SHOW_GUIA_DETALLE_SUPERSSM',
  // Lista tipos de solicitante (proceso DIMAR)
  LISTA_TIPOS_SOLICITANTE: 'TIPO_SOLICITANTE_DIMAR',
  TAMANIOS_NAVE_DIMAR: 'DIMAR_TAMANIO_NAVE',
  CODIGO_LESIONADO: 'LESIONADO',
  CODIGO_TERCEROS: 'TERC_INT',

  // Observatorio Administrador
  FRABIC_ADM: 'https://app.fabric.microsoft.com/home?experience=power-bi',

  // Observatorio - Power BI
  DESCARGA_TIMEOUT: 300000,

  // Justino - version
  JUSTINO_VERSION: '0.1.18',
  INTRO_PARAM: 'intro-no-aunth',
  VIDEO_SEEN: 'video_seen',
  ENCUESTA_POSITIVA: 'encuestaSatisfaccionJustino',
  ENCUESTA_NEGATIVA: 'encuestaSatisfaccionJustino2',
  JUSTINO_WHATSAPP: '573101234567',
  JUSTINO_WHATSAPP_MSG_P1: 'Su número de conversación es: ',
  JUSTINO_WHATSAPP_MSG_P2: ', por favor de ENTER o ENVIAR para continuar',
  CANTIDAD_CONVERSACIONES_HISTORIAL: 22,

  // Justino - rutas
  JUSTINO_RUTA_LOGIN: '/login',
  JUSTINO_RUTA_TRAMITES: '/tramites',

  //  Lista de tipo solicitante ROI
  ROI_TIPO_SOLICITANTE: 'Tipo_Solicitante ',
  MACROSECTOR: 'Macrosector',
  NATURALEZA: 'Naturaleza',
  CESE_PAGOS: 'Cese_Pagos',
  PREPARADOR_INFORMACION: 'Preparador_Informacion ',
  BASE_CONTABLE: 'Base_contable',
  CONDICION_DEUDOR: 'Condicion_deudor',
  MAIL_SUBJECT: 'En Justifácil puede encontrar estadísticas de los procesos jurisdiccionales del ejecutivo!!',
  MAIL_BODY: `En el siguiente enlace encontrará información que puede ser de su interés. Haga clic aquí`,
  CODIGO_CIIU: 'Codigo_CIIU',

  TIPO_IDENTIFICACION_NIT: 'NIT',
  TIPO_IDENTIFICACION_NIT_: 'NIT - Número de Identificación Tributaria',
  TIPO_IDENTIFICACION_CC: 'CC',
  TIPO_IDENTIFICACION_CC_: 'CC - Cédula de ciudadanía',
  TIPO_IDENTIFICACION_CE: 'CE',
  TIPO_IDENTIFICACION_CE_: 'CE - Cédula de extranjería',
  TIPO_IDENTIFICACION_CEDULA: 'CÉDULA',

  TIPOS_DOCUMENTOS: {
    CC: 1,
    CE: 2,
    NIT: 3,
    PASAPORTE: 4,
    TI: 5,
    TP: 6,
  },
  TIPO_PERSONA_NATURAL: 'Persona Natural',
  TIPO_PERSONA_JURIDICA: 'Persona Jurídica',
  NIVELES_EDUCATIVOS_EXCLUIDOS: ['Secundaria', 'Primaria', 'Bachillerato', 'Sin educación formal'],

  //  Pasos ROI
  PASOS_ROI: {
    PASO_1: 1,
    PASO_2: 2,
    PASO_3: 3,
    PASO_4: 4,
    PASO_5: 5,
    PASO_6: 6,
    PASO_7: 7,
    PASO_8: 8,
    PASO_9: 9,
    PASO_10: 10,
    PASO_11: 11,
    PASO_12: 12,
    PASO_13: 13,
    PASO_14: 14
  },

  //  Pasos VJ
  PASOS_VJ: {
    PASO_1: 1,
    PASO_2: 2,
    PASO_3: 3,
    PASO_4: 4,
    PASO_5: 5,
    PASO_6: 6,
    PASO_7: 7,
    PASO_8: 8,
    PASO_9: 9,
    PASO_10: 10,
    PASO_11: 11,
    PASO_12: 12,
    PASO_13: 13,
    PASO_14: 14,
    PASO_15: 15
  },
  CODIGO_ROI: 'SSO_ROI',
  CODIGO_LJI: 'SSO_LJI',
  CODIGO_VJI: 'SSO_VJI',

  MAPA_NOMBRE_CORTO_A_ID: {
    'SIC_COMP_DES': 1,
    'SIC_PROP_IND': 2,
    'SIC_PROIND_COMDES': 3
  } as { [key: string]: number },

  MAPA_NOMBRE_CORTO_A_TITULO_KEY: {
    'SIC_PROIND_COMDES': 'titulo-SIC_PROIND_COMDES',
    'SIC_COMP_DES': 'titulo',
    'SIC_PROP_IND': 'titulo-SIC_PROP_IND'
  } as { [key: string]: string },

  NOMBRES_MAP: {
    'Cobertura de Servicios': 'Cobertura de servicios incluidos en el Plan de Beneficios en Salud- PBS',
    'Conflictos Entre las Entidades': 'Conflictos entre las entidades',
    'Multiafiliación': 'Conflictos por multiafiliación dentro del Sistema General de Seguridad Social en Salud-SGSSS.',
    'Reconocimiento Económico': 'Reconocimiento económico por parte de la entidad',
    'Libre Elección Aseguradoras': 'Conflictos por libre elección y movilidad',
    'Conflictos Derivados de las Devoluciones': 'Conflictos derivados de las devoluciones o glosas a las facturas, reclamaciones y recobros de servicios No PBS'
  } as { [key: string]: string },

  TIPO_PRETENCION_A_ID: {
    'Cobertura de servicios Incluidos del Plan de Beneficios en Salud-PBS': 428,
    'Reconocimiento económico de gastos en salud': 429,
    'Conflictos por multiafiliación dentro del Sistema General de Seguridad Social en Salud-SGSSS': 430,
    'Conflictos por libre elección y movilidad': 431,
    'Conflictos derivados de las devoluciones o glosas a las facturas, reclamaciones y recobros de servicios No PBS': 432,
    'Conflictos entre las Entidades Administradoras de Planes de Beneficios y/o entidades que se le asimilen': 433,
  } as { [key: string]: number },

  // Cantidad máxima de archivos para adjuntar - Formularios insolvencia
  CANTIDAD_ARCHIVOS_INSOLVENCIA: 4,

  VALORES_TIPO_SOLICITANTE: {
    LESIONADO: 'Lesionado',
    TERCEROS_INTERESADOS: 'Terceros interesados',
  },

  PASOS: 'pasos',
  VALOR_S: 'S',
  VALOR_N: 'N',
  MEDIOS_TEC: 'medios',

  CESACION_PAGOS: 'Cesación de Pagos',
  LISTA_FESTIVOS: 'listaFestivos',
  DIAS_HABILES: 16,
  EVENTOS_VISIBLES_ENTIDAD: 6,
  TAMANIO_MAXIMO_ARCHIVOS_GBYTES: 2, // 2 GB,
  BYTES_POR_MB: 1024 * 1024,
  BYTES_POR_GB: 1024 ** 3,
  TAMANIO_MAXIMO_ARCHIVOS_MBYTES: 20, // 20 MB,

  EXPEDIENTE_DEBOUNCE_TIME: 3000,
  EXPEDIENTES_LENGTH: 0,

  DATO_COUNTRY_VALIDATE: 1,
  CREAR_CUENTA: 'crear-cuenta',

  DEPARTMENT_CAMPO: 'departmento',
  MUNICIPALITY_CAMPO: 'municipio',
  DEPARTEMENT_TIEMPO: 700,
  MUNICIPALITY_TIEMPO: 400,
  EVENTO: "Evento",
  DNDA: "DNDA_VDA",
  DIMAR: "DIMAR_COSIMAR",
  MIN_COUNT: 0,
  MAX_COUNT: 1,

  ACTORES: {
    DEMANDANTE: 'Demandante',
    APODERADO: 'Apoderado',
    DEMANDADO: 'Demandado',
  },

  DEMANDADOS: 'demandados',
  DEMANDANTES: 'demandantes',
  ARCHIVOS_SIC_PROCON_PASO_UNO: 'archivoUnoSicProcon',
  ARCHIVOS_SIC_PROCON_PASO_SIETE: 'archivoSieteSicProcon',

  TIPOS_DOCUMENTOS_PERSONAS: {
    CC: 1,
    CE: 2,
    NIT: 3,
    PASAPORTE: 4,
    TI: 5
  },
  FORM_INVALID:'FORM_INVALID',
  ANEXOS_INCOMPLETOS:'ANEXOS_INCOMPLETOS',
  TIPO_SOLICITUD_UNO:1,
  TIPO_SOLICITUD_DOS:2,
  TERMINOS_CONDICIONES_SIC:'TERMINOS_CONDICIONES_SIC',
  AVANCE_PROCESAL_SIC:'Avance_Procesal_SIC',
  INSTRUCCIONES_CREACION_EMPRESA: 'INSTRUCCIONES_CREACION_EMPRESA',
  PROCESO_CREACION_EMPRESA: 'PROCESO_CREACION_EMPRESA',
  DESCRIPCION: 'descripcion',
  TIPO_SOCIEDAD: 'ICA_TIPO_SOCIEDAD',
  ESTADO_SOLICITUD_EMPRESA: 'Estado_Solicitud_Empresa',
  PENDIENTE: 'Pendiente',
  MIN_LENGTH_IDENTIFICACION:4,
  MAX_LENGTH_IDENTIFICACION:12,
  MAX_LENGTH_IDENTIFICACION_PA:8,
  MAX_LENGTH_ASUNTO : 300,
  MAX_LENGTH_DESCRIPCION : 1000,
  MAX_LENGTH_NOMBRE : 50,
  MAX_LENGTH_APELLIDOS : 50,
  MAX_LENGTH_CORREO : 100,
  MAX_LENGTH_CEDULA : 20,
  Empresa: 'Empresa',
  URL_CMS: 'URL_CMS',
  POLLING_INTERVAL_MS: 30000,
  PESO_ARCHIVO_SIC:'PESO_ARCHIVOS_SIC',
  MAX_FILE_SIZE:1000,
  SERVICIO_RUES: 'RUES',
  CONSULTA_RUES: 'Consulta RUES',
  VALOR_TRUE: true,
  VALOR_FALSE: false,
  LOGIN_TIMESTAMP: 'loginTimestamp'
};
export const FILTRO_TIPO_DOCUMENTO_INSOLVENCIA = {
  PERSONA_TIPO_NATURAL: ["CC", "CE", "PP"],
  PERSONA_TIPO_JURIDICA: ["NIT"]
};

